import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import NightsStayOutlinedIcon from '@mui/icons-material/NightsStayOutlined';
import { IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import { useMBUITheme } from '../contexts/ThemeContextProvider';

const ThemeSwitchToggle = ({ showCaption }) => {
  const { activeThemeID, setActiveThemeID } = useMBUITheme();

  const onClick = (id) => {
    setActiveThemeID(id);
  };

  return (
    <IconButton
      sx={{
        borderColor: 'rgba(255, 255, 255, 0.5)',
        color: '#ffffff',
        ':hover': {
          borderColor: 'rgba(255, 255, 255, 1)',
        },
      }}
      onClick={() => {
        onClick(activeThemeID === 0 ? 1 : 0);
      }}
    >
      {activeThemeID === 0 ? (
        <NightsStayOutlinedIcon fontSize={'medium'} />
      ) : (
        <LightModeOutlinedIcon fontSize={'medium'} />
      )}
    </IconButton>
  );
};

ThemeSwitchToggle.propTypes = { showCaption: PropTypes.bool };

ThemeSwitchToggle.defaultProps = {
  showCaption: true,
};

export { ThemeSwitchToggle };
